const _undefined = (x) => x === undefined, _update = Object.assign, _keys = Object.keys, _values = Object.values, _freeze = Object.freeze;
export { _undefined, _update, _keys, _values, _freeze, };
